import styled from 'styled-components';

const Pointer = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.commons.tooltip.background};
  position: absolute;
  z-index: -1;
  top: -4px;
  transform: translate(-50%) rotate(45deg);
  left: ${({ isDesktop }) => (isDesktop ? '10%' : '50%')};
`;

export default Pointer;
